<template>
  <div>
    <base-jin-nang-panel title="交易查询">
      <template v-slot:bodyContent>
        <div class="filter">
          <div class="filter-timeBegin">
            <div class="filter-title">开始日期</div>
            <el-date-picker v-model="beginTime" placeholder=""></el-date-picker>
          </div>
          <div class="filter-timeEnd">
            <div class="filter-title">结束日期</div>
            <el-date-picker v-model="endTime" placeholder=""></el-date-picker>
          </div>
          <div class="btnQuery" @click="getTradePage">查询</div>
        </div>
        <base-jin-nang-table :titleList="titleList" :dataList="dataList">
        </base-jin-nang-table>
      </template>
      <template v-slot:footerContent>
        <div class="pager">
          <el-pagination
            background
            :total="total"
            :current-page="currentPage"
            :page-size="pageSize"
            @current-change="anotherTragePage"
            layout="prev, pager, next, total"
          ></el-pagination>
        </div>
      </template>
    </base-jin-nang-panel>
  </div>
</template>

<script>
import BaseJinNangPanel from '../BaseJinnangPanel/BaseJinNangPanel.vue'
import BaseJinNangTable from '../BaseJinNangTable/BaseJinNangTable.vue'
import { getAuthorJinNangTradePage } from '@/api/AuthorJinNang'
import dayjs from 'dayjs'

export default {
  name: 'AuthorJinNangCancle',
  components: { BaseJinNangPanel, BaseJinNangTable },
  data() {
    return {
      titleList: [
        { text: '类型', class: '' },
        { text: '证券代码', class: '' },
        { text: '证券名称', class: '' },
        { text: '成交时间', class: 'width100px' },
        { text: '成交价格', class: '' },
        { text: '成交数量', class: '' },
        { text: '成交金额', class: '' }
      ],
      pageSize: 30,
      fromIndex: 0,
      total: 0,
      viewState: '',
      pageEnd: true,
      tradeList: [],
      beginTime: '',
      endTime: ''
    }
  },
  created() {
    this.beginTime = this.endTime = dayjs(new Date()).format('YYYY-MM-DD')
    this.getTradePage()
  },
  computed: {
    currentJinNangId() {
      return this.$route.params.id
    },
    currentPage() {
      return this.fromIndex / this.pageSize + 1
    },
    beginTimeInt() {
      if (this.beginTime) return dayjs(this.beginTime).format('YYYYMMDD')
      else return 0
    },
    endTimeInt() {
      if (this.endTime) return dayjs(this.endTime).format('YYYYMMDD')
      else return 0
    },
    dataList() {
      if (this.tradeList) {
        return this.tradeList.map(a => ({
          tr: a,
          tds: [
            { text: a.tradeTypeName, class: '' },
            { text: a.secuCode, class: '' },
            { text: a.secuName, class: '' },
            { text: this.formatTime(a.dealTime), class: 'width100px' },
            { text: a.dealPriceStr, class: '' },
            { text: a.dealNumber, class: '' },
            { text: a.dealAmountStr, class: '' }
          ]
        }))
      } else {
        return []
      }
    }
  },
  methods: {
    async getTradePage() {
      if (this.beginTimeInt !== 0 && this.beginTimeInt > this.endTimeInt) {
        this.$message.error('结束日期必须大于开始日期')
      }
      const data = await getAuthorJinNangTradePage(
        {
          pageSize: this.pageSize,
          fromIndex: this.fromIndex,
          jinNangId: this.currentJinNangId,
          orderBy: 1,
          beginTme: this.beginTimeInt, // 注意服务端beginTime单词拼写错误
          endTime: this.endTimeInt,
          filter: 1
        },
        this.viewState
      )
      if (data && data.result.code === 0) {
        this.tradeList = data.detail.list
        this.fromIndex = data.detail.fromIndex
        this.total = data.detail.total
      }
    },
    formatTime(time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss')
    },
    async anotherTragePage(pageNo) {
      this.fromIndex = pageNo * this.pageSize + 1
      this.getTradePage()
    }
  }
}
</script>

<style lang="scss" scoped>
.operation-cell {
  width: 120px;
}
.cancleBtn {
  width: 60px;
  height: 24px;
  background-color: rgba(4, 107, 204, 0.1);
  border-radius: 12px;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 1px;
  text-align: center;
  color: #046bcc;
  margin: auto;
  cursor: pointer;
}

.pager {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}

.filter {
  margin-bottom: 30px;
  height: 34px;
  display: flex;
  align-items: center;
}

.filter > input {
  height: 34px;
}

.filter-title {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 34px;
  letter-spacing: 1px;
  color: #262626;
  margin-right: 10px;
}

.filter-timeEnd {
  margin-left: 30px;
  display: flex;
  align-items: center;
}
.filter-timeBegin {
  display: flex;
  align-items: center;
}

.btnQuery {
  width: 120px;
  height: 34px;
  background-color: #046bcc;
  border-radius: 5px;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 34px;
  letter-spacing: 1px;
  text-align: center;
  color: #ffffff;
  margin-left: 11px;
  cursor: pointer;
}
</style>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #046bcc;
  color: #fff;
}
</style>
